<template>
  <div
    :style="sideNavigationStyle"
    class="sticky hidden w-[209px] shrink-0 overflow-y-auto pl-0.5 pt-0.5 lg:block"
  >
    <SideNavigation
      :categories="sidebarCategories"
      :feching="fetchingCategories"
    />
  </div>
</template>

<script setup>
const { sideNavigationStyle } = useUiState()
const { sidebarCategories, fetchingCategories } = useNewPlp()
</script>
